(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
//
// GLOBAL LOADING
// ==============
// Appends a loading bar to the global 'toolbar' when required.
// This delay will allow ajax to return without showing the loader

module.exports = function (target, loadingDelay, debug) {

  debug('setting up global loading bar')

  var concurrentRequests = 0
    , finished = false
    , classAdded = false

  $(document).ajaxComplete(function () {

    concurrentRequests = concurrentRequests - 1

    if (concurrentRequests > 0) {
      return
    }

    debug('hiding global loading bar')

    var $toolbar = $(target)

    if ($toolbar.find('.global-loading').length > 0) {
      $toolbar.find('.global-loading').removeClass('currently-loading')

      finished = true
      if (!classAdded) {
        $toolbar.find('.global-loading').remove()
      } else {
        $('.global-loading').on(
          'transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd'
          , function () {
            debug('hiding global loading bar')
            $toolbar.find('.global-loading').remove()
          }
        )
      }
    }
  })

  $(document).ajaxSend(function () {

    concurrentRequests += 1

    var $toolbar = $(target)

    if ($toolbar.find('.global-loading-content').length > 0) {
      return
    }
    finished = false
    classAdded = false

    debug('appending global loading bar')

    var $loaderContent = $('<span />').addClass('global-loading-content').text('Loading')
      , $loader = $('<div />').addClass('global-loading').append($loaderContent)

    $toolbar.append($loader)

    window.setTimeout(function () {
      debug('showing global loading bar')
      if (!finished) {
        classAdded = true
        $loader.addClass('currently-loading')
      }
    }, loadingDelay)
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/global-loading.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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